import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Flex, Input, Text } from '@workwhile/ui'
import { defs } from 'components/Shared/defs'
import { device } from 'components/Shared/device'
import { useFieldglassJobPostingContextValue } from '../context/FieldglassJobPostingProvider'

export const FieldglassJobPostingSearchBar = () => {
  const {
    state: { jobPostingId },
    actions: { setJobPostingId },
  } = useFieldglassJobPostingContextValue()

  const [input, setInput] = useState(jobPostingId ?? '')

  useEffect(() => {
    setInput(jobPostingId ?? '')
  }, [jobPostingId])

  const handleSearch = () => {
    const trimmed = input.trim()
    setJobPostingId(trimmed === '' ? null : trimmed)
  }

  return (
    <FilterBarWrapper showBorderTop showBorderBottom>
      <JobPostingIdField>
        <Text fontSize={1} color="lightText" mb={1}>
          Fieldglass Job Posting ID
        </Text>
        <Flex alignItems="center" gap={2}>
          <Input
            value={input}
            onChange={(event) => setInput(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleSearch()
              }
            }}
            placeholder="PFGJP00011785"
            style={{ minWidth: 220 }}
          />
          <Button kind="small" onClick={handleSearch} disabled={input === ''}>
            Search
          </Button>
        </Flex>
      </JobPostingIdField>
    </FilterBarWrapper>
  )
}

const FilterBarWrapper = styled.div<{
  showBorderTop?: boolean
  showBorderBottom?: boolean
}>`
  border-bottom: ${(props) => (props.showBorderBottom ? '1px solid' : null)};
  border-top: ${(props) => (props.showBorderTop ? '1px solid' : null)};
  border-color: ${defs.veryLightBlack};
  padding: ${defs.paddingS};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fafafa;
  @media ${device.smallerThanMobileL} {
    font-size: ${defs.fontS};
    height: 100%;
    padding-left: ${defs.paddingM};
  }
`

const JobPostingIdField = styled.div`
  margin-top: ${defs.marginXS};
  margin-bottom: ${defs.marginXS};
`
